(() => {
  if (window.__b2bStudiosInit) return;
  window.__b2bStudiosInit = true;

  document.addEventListener('DOMContentLoaded', () => {
    const instances = new Map();

    const destroyFor = id => {
      const existing = instances.get(id);
      if (!existing) return;
      existing.destroy(true, true);
      instances.delete(id);
    };

    const initSlider = root => {
      const id = root.dataset.sectionId;
      if (!id) return;
      const sliderEl = root.querySelector('.b2b-studios__swiper');
      if (!sliderEl) return;
      if (typeof Swiper === 'undefined') return;

      destroyFor(id);

      const scope = `#shopify-section-${id}`;

      const swiper = new Swiper(sliderEl, {
        slidesPerView: 'auto',
        spaceBetween: 8,
        watchOverflow: true,
        loop: root.dataset.loop === 'true',
        loopAdditionalSlides: 1,
        loopPreventsSliding: false,
        navigation: {
          enabled: false,
          nextEl: `${scope} .b2b-studios__nav--next`,
          prevEl: `${scope} .b2b-studios__nav--prev`
        },
        scrollbar: {
          enabled: true,
          el: `${scope} .b2b-studios__scrollbar`,
          draggable: false,
          dragSize: 'auto'
        },
        breakpoints: {
          1024: {
            spaceBetween: 16,
            navigation: { enabled: true },
            scrollbar: { enabled: false }
          }
        }
      });

      swiper.on('slideChange', () => {
        if (typeof calculateScrollPercentage !== 'function') return;
        calculateScrollPercentage(swiper, '.b2b-studios__title');
      });

      instances.set(id, swiper);
    };

    const initAll = ctx => {
      const scope = ctx || document;
      scope
        .querySelectorAll('.b2b-studios__inner[data-section-id]')
        .forEach(initSlider);
    };

    initAll();

    document.addEventListener('shopify:section:load', e => initAll(e.target));
    document.addEventListener('shopify:section:unload', e => {
      const root = e.target.querySelector(
        '.b2b-studios__inner[data-section-id]'
      );
      if (root) destroyFor(root.dataset.sectionId);
    });
  });
})();
